"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorType = void 0;
var ErrorType;
(function (ErrorType) {
    ErrorType["AUTHENTICATION_FAILED_ERROR"] = "AuthenticationFailedError";
    ErrorType["INVALID_INPUT_ERROR"] = "InvalidInputError";
    ErrorType["MULTI_FACTOR_PAYMENT_AUTHENTICATION_EXCEPTION"] = "MultiFactorPaymentAuthenticationException";
    ErrorType["NOT_FOUND_ERROR"] = "NotFoundError";
    ErrorType["PAYMENT_INSTRUMENT_ERROR"] = "PaymentInstrumentError";
    ErrorType["UNEXPECTED_ERROR"] = "UnexpectedError";
    ErrorType["SHOPPING_PORTAL_REDIRECT_ERROR"] = "ShoppingPortalRedirectError";
    ErrorType["CLIENT_SIDE_NETWORK_ERROR"] = "ClientSideNetworkError";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
